// Side-effect imports (styles)
import "./Branding.css";

/**
 * ActicaGroup
 * -----------
 * Presentational component that renders the "Part of the ACTICA Group"
 * credit and three brand/logo placeholders.
 *
 * Notes:
 * - Logos live in `/public/assets/...`, so we reference them by absolute path.
 * - Images are decorative; `alt=""` ensures screen readers skip them.
 */

// TYPES -------------------------------------------------------------
type ActicaGroupProps = {
  className?: string;
  ariaLabel?: string;
};

// COMPONENT ---------------------------------------------------------
const ActicaGroup: React.FC<ActicaGroupProps> = ({
  className = "",
  ariaLabel = "ACTICA Group logos",
}) => {
  /** RENDER -------------------------------------------------------- */
  return (
    <div className={`actica-group ${className}`} aria-label={ariaLabel}>
      <p>Part of the ACTICA Group</p>

      <div className="group-logos" aria-hidden="true">
        <img className="logo actica" src="/assets/logos/actica-consulting.svg" alt="" />
        <img className="logo ntegra" src="/assets/logos/ntegra.svg" alt="" />
        <img className="logo gemba" src="/assets/logos/gemba-advantage.svg" alt="" />
      </div>
    </div>
  );
};

export default ActicaGroup;
